import React from "react";
/** composants **/
import { Navbar } from '../Navbar';
import Footer from '../components/Footer';
import { Helmet } from "react-helmet";
import BackHeaderTop from "../components/BackHeaderTop";
import { Link } from 'react-router-dom';


export default function Outils(args) {
  return (
    <>
      <Helmet>
        <title>Clotere.fr simplifie votre passage chez le notaire | Calculateur et simulateur de frais de notaire</title>
        <meta name="robots" content="index,follow" />
        <meta name="googlebot" content="index,follow" />
        <meta name='description' content='Clotere.fr vous permet de gérer et simplifier vos démarches chez le notaire en ligne : contrat de mariage, documents notariés PMA, trouver un notaire pour acheter un bien immobilier, vendre son bien immobilier, trouver un notaire, etc' />
        <meta property="og:url" content="https://clotere.fr" />
        <meta property="og:site_name" content="Clotere" />
        <meta property="og:image" content="https://clotere.fr/facebook-share-webp" />
        <meta property="og:type" content="website" />
      </Helmet>

      <div>
        <Navbar user={args.user} />

        <div className="py-12 relative">
          <BackHeaderTop />

          <div className="mx-auto max-w-7xl px-6 lg:px-8">
            <div className="mb-12 flex justify-center gap-4 flex-wrap">
              <h1>Outils et simulateurs frais  de notaire</h1>
            </div>

            <div className="mx-auto grid max-w-2xl grid-cols-1 gap-x-8 gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-3">
                <article  className="flex flex-col items-start justify-between">
                  <div className="relative w-full">
                    <img
                      alt="simulateur frais de notaire immobilier"
                      src="https://images.unsplash.com/photo-1512075135822-67cdd9dd7314?q=80&w=3024&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                      className="aspect-video w-full rounded-2xl bg-gray-100 object-cover sm:aspect-2/1 lg:aspect-3/2"
                    />
                    <div className="absolute inset-0 rounded-2xl ring-1 ring-gray-900/10 ring-inset" />
                  </div>
                  <div className="max-w-xl">
                    <div className="mt-8 flex items-center gap-x-4 text-xs">
                      <span className="no-underline relative z-10 rounded-full bg-indigo-100 px-3 py-1.5 font-medium text-gray-600">
                        Frais de notaire immobilier
                      </span>
                    </div>
                    <div className="group relative">
                      <h3 className="mt-3 text-lg/6 font-semibold group-hover:text-gray-600">
                      <Link to="/outils/calculateur-frais-de-notaire-immobilier" className="no-underline text-gray-900">
                          <span className="absolute inset-0" />
                          Simulateur frais de notaire immobilier
                        </Link>
                      </h3>
                      <p className="line-clamp-3 text-sm/6 text-gray-600">Obtenez gratuitement une estimation de vos frais de notaire en immobilier</p>
                    </div>
                    <div className="relative mt-8 flex items-center gap-x-4">
                      <img
                        alt="Clotere simulateur frais de notaire immobilier"
                        src="https://framerusercontent.com/images/Cihku2yTTOUo6fm04vXVGhV7Q.png"
                        className="size-10 rounded-full bg-gray-100"
                      />
                      <div className="text-sm/6">
                        <p className="font-semibold text-gray-900 m-0">Clotere</p>
                      </div>
                    </div>
                  </div>
                </article>


                <article  className="flex flex-col items-start justify-between">
                  <div className="relative w-full">
                    <img
                      alt="simulateur frais de notaire immobilier"
                      src="https://images.unsplash.com/photo-1520854221256-17451cc331bf?q=80&w=3270&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
                      className="aspect-video w-full rounded-2xl bg-gray-100 object-cover sm:aspect-2/1 lg:aspect-3/2"
                    />
                    <div className="absolute inset-0 rounded-2xl ring-1 ring-gray-900/10 ring-inset" />
                  </div>
                  <div className="max-w-xl">
                    <div className="mt-8 flex items-center gap-x-4 text-xs">
                      <span className="no-underline relative z-10 rounded-full bg-indigo-100 px-3 py-1.5 font-medium text-gray-600">
                        Cout contrat de mariage
                      </span>
                    </div>
                    <div className="group relative">
                      <h3 className="mt-3 text-lg/6 font-semibold group-hover:text-gray-600">
                        <Link to="/outils/calculateur-prix-contrat-mariage"  className="no-underline text-gray-900">
                          <span className="absolute inset-0" />
                          Simulateur Prix Contrat de mariage notaire
                        </Link>
                      </h3>
                      <p className="line-clamp-3 text-sm/6 text-gray-600">Obtenez gratuitement la tarif de votre contrat de mariage chez le notaire</p>
                    </div>
                    <div className="relative mt-8 flex items-center gap-x-4">
                      <img
                        alt="Calculez le prix de votre contrat de mariage chez le notaire"
                        src="https://framerusercontent.com/images/Cihku2yTTOUo6fm04vXVGhV7Q.png"
                        className="size-10 rounded-full bg-gray-100"
                      />
                      <div className="text-sm/6">
                        <p className="font-semibold text-gray-900 m-0">Clotere</p>
                      </div>
                    </div>
                  </div>
                </article>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}
